import { useEffect, useState } from "react";
import DialogWindow from "../../../CommonComponents/DialogWindow/DialogWindow";
import { deleteDraft, getAllDraftsForTemplate } from "../../Api";
import { usePrsInfo } from "../../effects";
import "./DraftWindow.scss";

function DraftWindow(props) {
	const prsInfo = usePrsInfo();
	const [update, setUpdate] = useState(false);
	const drafts = useDrafts(
		props.currentTemplateInfo.id,
		prsInfo.prs_alias,
		update
	);
	const handleDraftSelected = (data) => {
		const form = props.formRef.current;
		const formData = new FormData(form);
		const draftData = JSON.parse(data);
		Object.keys(draftData).map((key) => {
			formData.set(key, draftData[key]);
		});
		console.log(formData);
		for (const [key, val] of formData.entries()) {
			const input = props.formRef.current.elements[key];
			switch (input.type) {
				case "checkbox":
					input.checked = !!val;
					break;
				default:
					input.value = val;
					break;
			}
		}
		props.setOpenDraftDialog(false);
	};
	const handleDeleteDraft = (id) => {
		deleteDraft(id).then((res) => setUpdate((prev) => !prev));
	};
	return (
		<DialogWindow setOpen={props.setOpenDraftDialog}>
			<>
				<h2>Архив</h2>
				{drafts.map((item) => (
					<div className='draft-window-row'>
						<div className='draft-name'>{item.DRAFT_NAME}</div>
						<div className='buttons-block'>
							<button
								onClick={() => {
									handleDraftSelected(item.DRAFT_DATA);
								}}
							>
								Загрузить
							</button>
							<button
								onClick={() => {
									handleDeleteDraft(item.ID);
								}}
							>
								Удалить
							</button>
						</div>
					</div>
				))}
				<button onClick={() => props.setOpenDraftDialog(false)}>Закрыть</button>
			</>
		</DialogWindow>
	);
}

const useDrafts = (id, prsAlias, update) => {
	const [drafts, setDrafts] = useState([]);
	useEffect(() => {
		getAllDraftsForTemplate(id, prsAlias).then((res) => {
			if (res.length > 0) {
				res.reverse();
				setDrafts(res);
			}
		});
	}, [id, prsAlias, update]);

	return drafts;
};

export default DraftWindow;
